<template>
  <v-container>
    <v-row class="d-flex flex-row flex-wrap" v-if="!selected.id">
      <v-col v-for="m in vmeters" :key="m.id" lg="4" md="6" sm="12">
        <v-card link @click="selected = m" color="#27ae60" dark flat outlined>
          <v-img class="vm-logo" src="@/assets/logo vertebra blanco.svg" width="100%"></v-img>
          <v-card-text>{{ m.nombre }}</v-card-text>
        </v-card>
      </v-col>
      
    </v-row>
    <v-row v-if="selected.id">
      <v-col>
        <v-btn text outlined color="success" @click="selected = {}">
          <v-icon>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
        <!-- <a href="javascript:void(0)" @click="selected = {}">Volver</a> -->
        <v-divider class="my-2"></v-divider>
        <div class="vtmeter-viewer">
          <div class="header">
            <img src="@/assets/logo vertebra blanco.svg" alt />
            <span>{{ selected.nombre.toUpperCase() }}</span>
          </div>
          <iframe v-if="!selected.egauge" :src="`https://vertebra${selected.id}.vertebrameters.com`" scrolling="no" frameborder="0" allowfullscreen="yes"></iframe>
          <iframe v-if="selected.egauge" :src="`http://egauge${selected.id}.egaug.es`" scrolling="no" frameborder="0" allowfullscreen="yes"></iframe>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import { apiv1 } from "../../libs/apiv1";
import { oAuth } from "../../classes/Auth";

const oauth = oAuth;

export default Vue.extend({
  name: "RealTime",
  data: () => ({
    vmeters: [],
    selected: {}
  }),
  created() {
    this.getVmeters();
  },
  methods: {
    getVmeters() {
      apiv1({
        url: `vmeters/${oauth.getProject().id}`,
        method: "GET"
      }).then(res => {
        console.log(res.data);
        this.vmeters = res.data;
      });
    }
  }
});
</script>
<style lang="scss" scoped>
.v-card {
  .v-image {
    max-height: 100px;
    background: #fff;
  }
}

.vtmeter-viewer {
  position: relative;
  .header {
    display: flex;
    width: 100%;
    background: #fff;
    height: 54px;
    position: absolute;
    left: 0;
    top: 0;
    justify-content: space-between;
    align-items: center;
    padding-right: 40px;

    img {
      width: 300px;
    }

    span {
      font-size: 1.5em;
    }
  }
  iframe {
    width: 100%;
    height: 115vh;
  }
}
</style>